import { useSelector, shallowEqual } from 'react-redux';
import { useMemo } from 'react';
import { RootState } from './types';
import { isEmptyOrNull } from '../../utils/DataUtils';

const useCommonDataConfig = () => {
    const commonDataConfig = useSelector((state: RootState) => state.configurations, shallowEqual);

    const servicePropositionList = useMemo(() => {
        if (!isEmptyOrNull(commonDataConfig?.servicePropositionRecord)) {
            return commonDataConfig.servicePropositionRecord.data;
        }
        return [];
    }, [commonDataConfig]);

    return {
        servicePropositionList,
    }
};

export default useCommonDataConfig;